import React, { useMemo, useState } from 'react';

// Styles & Assets
import styles from './AnswerPollForm.module.css';

// Hooks
import { useTranslation } from 'react-i18next';

// Components
import QuestionsForm from '../../UI/QuestionsForm/QuestionsForm';

// Interfaces
import { Poll, PollAnswer, PollQuestion } from '../../../interfaces/Poll';

interface Props {
    poll: Poll | undefined;
    handleClickSend: (questions: PollQuestion[]) => void;
    closeDialog: () => void;
}

const AnswerPollForm: React.FC<Props> = ({ poll, handleClickSend, closeDialog }) => {
    const { t } = useTranslation();

    const questions = useMemo<PollQuestion[]>(() => poll?.questions ?? [], [poll]);

    const [selectedAnswers, setSelectedAnswers] = useState<Record<number, PollAnswer>>({});

    const updateAnswer = (answer: PollAnswer | undefined) => {
        const questionId = answer?.inquiry_question_id;
        const selectedAnswer = answer;

        if (questionId === undefined || questionId === null) return;

        setSelectedAnswers(old => {
            const copy = { ...old };

            if (selectedAnswer === undefined) {
                delete copy[questionId];
                return copy;
            }

            copy[questionId] = selectedAnswer;
            return copy;
        });
    };

    const onConfirm = () => {
        const questionsToSend = questions.map(q => ({
            ...q,
            answers: q.id !== undefined && q.id !== null && selectedAnswers[q.id]
                ? [selectedAnswers[q.id]]
                : []
        }));

        handleClickSend(questionsToSend);
    };

    const disabledButton =
        poll === undefined ||
        questions.length === 0 ||
        questions.some(q => q.required && (q.id === undefined || q.id === null || !selectedAnswers[q.id]));

    return (
        <div>
            <div className={styles.questionsContainer}>
                <QuestionsForm
                    questions={questions}
                    updateAnswer={updateAnswer}
                />
            </div>
            <div className={styles.buttonsContainer}>
                <button onClick={closeDialog} className={`button ${styles.cancel}`}>
                    {t('cancel')}
                </button>
                <button disabled={disabledButton} onClick={onConfirm} className={`button ${styles.send}`}>
                    {t('send')}
                </button>
            </div>
        </div>
    );
};

export default AnswerPollForm;